<ng-container *ngIf="!dems && showLinkBanner && !suppressLinkBanner">
    <div class="card-link">
        <div [innerHtml]="ct_banner | safeHtml" [attr.data-qa]="'link_banner'"></div>
    </div>
</ng-container>